import React, { useEffect, useState, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import toast from "react-hot-toast";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  TextField
} from "@material-ui/core";
import IssueNumberService from "../services/IssueNumberService";
import { useBrand } from "./../helper/BrandContext";

const IssueNumbers = ({ isLoggedIn }) => {
  const { brand } = useBrand();
  const issueNumberService = new IssueNumberService();
  const surveyLink = useRef(null);
  const [tableRequest, setTableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "createdDate",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0,
    BrandId: 0
  });
  const [state, setState] = useState({
    first: 0,
    sales: [],
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    sortOrder: ""
  });
  const [triggerDownload, setTriggerDownload] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({
    salesOrderNo: "",
    FromNo: "",
    ToNo: "",
    issueQty: "",
    createdBy: tableRequest.UserId,
    brandId: 0
  });
  const navigate = useNavigate();

  const [formErrors, setFormErrors] = useState({
    salesOrderNo: "",
    FromNo: "",
    ToNo: "",
    issueQty: ""
  });

  useEffect(() => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    if (brand) {
      tableRequest.BrandId = brand;
      setFormData((prevFormData) => ({
        ...prevFormData,
        brandId: brand
      }));
      const storedToken = sessionStorage.getItem("token");
      if (storedToken) {
        isLoggedIn(true);
      } else {
        isLoggedIn(false);
        navigate("/login");
      }
      fetchIssueData();
      GetFromNo();
    }
  }, [isLoggedIn, navigate, brand]);

  useEffect(() => {
    if (triggerDownload) {
      surveyLink.current.link.click();
      setTriggerDownload(false); // Reset the trigger after download
    }
  }, [triggerDownload]);

  function fetchIssueData() {
    issueNumberService
      .GetIssueNumbers(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setState((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales,
            loading: false
          }));
        } else {
          setState((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  }

  const searchFilter = (e) => {
    const value = e.target.value;
    setState((prevData) => ({
      ...prevData,
      loading: false
    }));
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchIssueData();
  };

  const getLazyLoadingValues = (event) => {
    setState((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setState((prevData) => ({
      ...prevData,
      sortOrder: state.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchIssueData();
  };

  const onPage = (event) => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    getLazyLoadingValues(event);
    fetchIssueData();
  };

  function GetFromNo() {
    issueNumberService
      .GetFromNumbers(tableRequest.BrandId)
      .then((response) => {
        const data = response.responseData[0].fromNo;
        setFormData((prevFormData) => ({
          ...prevFormData,
          FromNo: data
        }));
      })
      .catch((error) => {
        console.error("API request failed:", error);
      });
  }
  const handleDialogOpen = () => {
    GetFromNo();
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setFormErrors({
      salesOrderNo: "",
      FromNo: "",
      ToNo: "",
      issueQty: ""
    });
  };

  const handleFormChange = (event) => {
    const { name, value } = event.target;

    // Assuming 'issueQty' and 'FromNo' are numeric values
    if (name === "issueQty") {
      const issueQty = parseFloat(value);
      const FromNo = parseFloat(formData.FromNo); // Assuming 'FromNo' is already set

      if (!isNaN(issueQty) && !isNaN(FromNo)) {
        const ToNo = FromNo + issueQty - 1;
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
          ToNo: ToNo.toString() // Convert to string if necessary
        }));
        formData.issueQty = issueQty;
        formData.ToNo = ToNo.toString();
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
          ToNo: "" // Set to empty if values are invalid
        }));
      }
    }
    validateForm(name, value);
  };

  const validateForm = (name, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
    const errors = formErrors;
    let IsValid = true;
    switch (name) {
      case "salesOrderNo":
        if (value.length < 1) {
          IsValid = false;
          errors.salesOrderNo = "Please enter sales order number.";
        } else errors.salesOrderNo = "";
        break;
      case "FromNo":
        if (value.length < 1) {
          IsValid = false;
          errors.FromNo = "Please enter From No.";
        } else errors.FromNo = "";
        break;
      case "ToNo":
        if (value.length < 1) {
          IsValid = false;
          errors.ToNo = "Please enter To No.";
        } else {
          errors.ToNo = "";
        }
        break;
      case "issueQty":
        if (value.length < 1) {
          IsValid = false;
          errors.issueQty = "Please enter issue qty.";
        } else {
          errors.issueQty = "";
        }
        break;
      default:
        break;
    }

    setFormErrors(errors);
    return IsValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let isfrmvalid = true;
    let checkerror = formErrors;

    Object.entries(checkerror).map(([key, value]) => {
      const val = formData[key];
      let valid = validateForm(key, val);
      if (!valid) {
        setFormErrors(checkerror);
        isfrmvalid = false;
      }
      return isfrmvalid;
    });
    if (isfrmvalid) {
      try {
        issueNumberService.CreateIssueNumber(formData).then((res) => {
          if (res.responseCode == "200") {
            toast.success(res.responseMessage);
          } else {
            toast.error(res.responseMessage);
          }
          setFormData((prevFormData) => ({
            ...prevFormData,
            salesOrderNo: "",
            FromNo: "",
            ToNo: "",
            issueQty: ""
          }));
          handleDialogClose();
          fetchIssueData();
        });
      } catch (error) {
        console.error("Error creating issue data:", error);
      }
    }
  };

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center mb-4 md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          Issue Number
        </h1>
      </div>
      <div className="search-export-container flex items-center">
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> */}
        </div>
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
          variant="contained"
          onClick={handleDialogOpen}
        >
          (+) Add Issue Number
        </button>
      </div>
    </div>
  );

  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <div className="mt-3">
              <div className="container-fluid mt-3 mb-3">
                <DataTable
                  exportFilename="DeMapping Report"
                  responsive={true}
                  header={header}
                  globalFilter={state.globalFilter}
                  emptyMessage={state.emptyMessage}
                  value={state.sales}
                  paginator={true}
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  rows={state.rows}
                  rowsPerPageOptions={[10, 50, 200, 500]}
                  totalRecords={state.totalRecords}
                  lazy={true}
                  first={state.first}
                  onPage={onPage}
                  onSort={onSort}
                  className="p-datatable-responsive"
                >
                  <Column
                    field="salesOrderNo"
                    header="Sales Order Number"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="fromNo"
                    header="From Number"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="toNo"
                    header="To Number"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="issueQty"
                    header="Issue Qty"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="formattedCreatedDate"
                    header="Created Date"
                    sortable={true}
                    style={{ width: "100px" }}
                  />
                </DataTable>
              </div>
            </div>
          </div>

          <Dialog open={openDialog} onClose={handleDialogClose} className="add">
            {/* <DialogTitle></DialogTitle> */}
            <div className="modal-header">
              <h5 className="modal-title adduser">Add Issue Number</h5>
            </div>

            <form onSubmit={handleSubmit}>
              <DialogContent>
                <TextField
                  margin="dense"
                  label="Sales Order Number"
                  type="text"
                  name="salesOrderNo"
                  value={formData.salesOrderNo}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.salesOrderNo}
                  helperText={formErrors.salesOrderNo}
                />
                <TextField
                  margin="dense"
                  label="From Number"
                  type="text"
                  name="FromNo"
                  value={formData.FromNo}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.FromNo}
                  helperText={formErrors.FromNo}
                />
                <TextField
                  margin="dense"
                  label="Issue Quantity"
                  type="text"
                  name="issueQty"
                  value={formData.issueQty}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.issueQty}
                  helperText={formErrors.issueQty}
                />
                <TextField
                  margin="dense"
                  label="To Number"
                  type="text"
                  name="ToNo"
                  value={formData.ToNo}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.ToNo}
                  helperText={formErrors.ToNo}
                />

                <div className="row justify-content-center">
                  <div className="col-md-6">
                    <DialogActions>
                      <Button
                        onClick={handleDialogClose}
                        className="can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="button"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                        className="sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </div>
                </div>
              </DialogContent>
            </form>
          </Dialog>
        </div>
      )}
    </div>
  );
};

export default IssueNumbers;
